import useSWR from 'swr';

/** Obtain adjustment data by adjustment id
 * @param adjustmentId - The id of the adjustment
 * @param allowRequest
 */
const useAdjustmentDetails = ({
  adjustmentId,
  allowRequest = true,
}: {
  adjustmentId?: string;
  allowRequest?: boolean;
}) => {
  const { data, isLoading, error } = useSWR(
    () => (allowRequest && adjustmentId ? `/audit/adjustment/${adjustmentId}` : false),
    {
      revalidateOnFocus: false,
    }
  );
  return { data: data ?? [], isLoading, error };
};

export default useAdjustmentDetails;
